export default __webpack_public_path__ + "static/media/76-mobile.d9d94146.jpg";